import { render } from "./OlasBlancas.vue?vue&type=template&id=73980128&scoped=true"
import script from "./OlasBlancas.vue?vue&type=script&lang=js"
export * from "./OlasBlancas.vue?vue&type=script&lang=js"

import "./OlasBlancas.vue?vue&type=style&index=0&id=73980128&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73980128"]])

export default __exports__